import { useState } from 'react';

const useCsiModal = () => {
  const [starIndex, setStarIndex] = useState(0);
  const [starIndexHover, setStarIndexHover] = useState(0);
  const [value, setValue] = useState('');

  const rates = ['veryBad', 'bad', 'normal', 'good', 'excellent'];
  const handleChange = (event: any) => {
    setValue(event.target.value);
  };

  return {
    starIndex,
    setStarIndex,
    value,
    setValue,
    handleChange,
    rates,
    starIndexHover,
    setStarIndexHover,
  };
};

export default useCsiModal;
